import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { isEmail, isNotEmpty, hasMinlength } from "./util/validation";

export default function SignUp() {
  const navigate = useNavigate();
  const [enterValue, setEnterValue] = useState({
    fullname: "",
    email: "",
    password: "",
    phone: "",
  });
  const [errors, setErrors] = useState({});
  //hàm dữ liệu
  function handleValueChange(id, value) {
    setEnterValue((pre) => ({
      ...pre,
      [id]: value,
    }));
  }
  //hàm validate
  function validateForm() {
    const newErrors = {};
    if (!isNotEmpty(enterValue.fullname)) {
      newErrors.fullName = "Please enter your fullname.";
    }
    if (!isEmail(enterValue.email) || !isNotEmpty(enterValue.email)) {
      newErrors.email = "Please enter a valid email address.";
    } else {
      const existingUers = JSON.parse(localStorage.getItem("userArr")) || [];
      if (existingUers.some((user) => user.email === enterValue.email)) {
        newErrors.email = "This email is already registered.";
      }
    }
    if (!hasMinlength(enterValue.password, 8)) {
      newErrors.password = "Password must be at least 8 characters long.";
    }
    if (!isNotEmpty(enterValue.phone)) {
      newErrors.phone = "Please enter your phone number.";
    }
    return newErrors;
  }

  function handleSubmit(e) {
    e.preventDefault();
    console.log(enterValue);
    const newErrors = validateForm();
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      // không có error
      const existingUsers = JSON.parse(localStorage.getItem("userArr")) || [];
      const newUser = { ...enterValue };
      existingUsers.push(newUser);
      localStorage.setItem("userArr", JSON.stringify(existingUsers));

      //alert("Registration successful! Redirecting to Sign In page...");
      navigate("/signin");
    }
  }

  return (
    <div className=" container">
      <div className="sign-up text-muted fst-italic">
        <div className="text-center form-container">
          <h2 className="mb-4 h2-signup">Sign Up</h2>
          <form className="form-signup" onSubmit={handleSubmit}>
            <div>
              <input
                className="input-signup"
                type="text"
                placeholder="Full Name"
                id="fullname"
                value={enterValue.fullname}
                onChange={(e) => handleValueChange("fullname", e.target.value)}
              />
              {errors.fullName && (
                <div className="error-text">{errors.fullName}</div>
              )}
            </div>
            <div>
              <input
                className="input-signup"
                type="text"
                placeholder="Email"
                id="email"
                value={enterValue.email}
                onChange={(e) => handleValueChange("email", e.target.value)}
              />
              {errors.email && <div className="error-text">{errors.email}</div>}
            </div>
            <div>
              <input
                className="input-signup"
                type="text"
                placeholder="Password"
                id="password"
                value={enterValue.password}
                onChange={(e) => handleValueChange("password", e.target.value)}
              />
              {errors.password && (
                <div className="error-text">{errors.password}</div>
              )}
            </div>
            <div>
              <input
                className="input-signup"
                type="text"
                placeholder="Phone"
                id="phone"
                value={enterValue.phone}
                onChange={(e) => handleValueChange("phone", e.target.value)}
              />
              {errors.phone && <div className="error-text">{errors.phone}</div>}
            </div>
            <div>
              <button className="btn-signup" type="submit">
                SIGN UP
              </button>
            </div>
            <div className="text-center p-t-45 p-b-4">
              <span>Login?</span>
              &nbsp;
              <Link to="/signin" className="link-signup">
                Click
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
